import { render, staticRenderFns } from "./checkbox.renderer.vue?vue&type=template&id=646ce900&"
import script from "./checkbox.renderer.vue?vue&type=script&lang=js&"
export * from "./checkbox.renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports